import { Block, Inline } from '@contentful/rich-text-types'
import { ContentfulRichText, Pullquote } from '@superhi/design'
import React from 'react'

import { Wrapper } from './styles'

type Props = {
  children: Block | Inline
}

const RICHTEXT_1_NODE_OVERRIDES: React.ComponentProps<typeof ContentfulRichText>['nodeOverrides'] =
  {
    paragraph: (_, c) => {
      return <>{c}</>
    },
    blockquote: (_, c) => {
      return <Pullquote color="BLUE_50">{c}</Pullquote>
    },
  }

const Blockquote: React.FC<Props> = ({ children }) => (
  <Wrapper>
    <ContentfulRichText nodeOverrides={RICHTEXT_1_NODE_OVERRIDES}>
      {JSON.stringify(children)}
    </ContentfulRichText>
  </Wrapper>
)

export default Blockquote
